import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import Model3DViewerCAD from './Model3DViewerCAD';

function ModelViewerWithToggle({ modelUrl, modelRotation, modelDebug }) {
  const [fileExists, setFileExists] = useState(true);

  useEffect(() => {
    if (modelUrl) {
      fetch(modelUrl, { method: 'HEAD' })
        .then(res => setFileExists(res.ok))
        .catch(() => setFileExists(false));
    }
  }, [modelUrl]);

  if (!modelUrl) {
    return (
      <Alert severity="info" sx={{ m: 2 }}>
        No 3D model available for this project.
      </Alert>
    );
  }

  if (!fileExists) {
    return (
      <Alert severity="warning" sx={{ m: 2 }}>
        3D model file not found. It may have been moved or deleted.
      </Alert>
    );
  }

  return <Model3DViewerCAD modelUrl={modelUrl} modelRotation={modelRotation} modelDebug={modelDebug} />;
}

export default ModelViewerWithToggle;
